// src/data/rulePresenceView.js
//
// 6a-12 (2026-09-14, task list section 243). What a Local Chairperson is told about a rule the
// analysis returns intermittently, and the rule that a claimant is told nothing. Pure.
import { RULE_PRESENCE } from './rulePresence';

// The id the analysis stamps on a matched rule is `violationId`; older rows carry `ruleId` only.
export function presenceOf(rule, presence) {
  const P = presence || RULE_PRESENCE;
  const id = rule && (rule.violationId || rule.ruleId);
  if (!id || !P || !P.rates || !P.rates[id]) return null;
  const r = P.rates[id];
  return { id, n: r.n, runs: P.runs, rate: r.rate, intermittent: r.n > 0 && r.n < P.runs };
}

// Officers only. A claimant sees nothing of this (6a-12: "never to the claimant").
export function presenceLabel(rule, user, presence) {
  const officer = !!(user && (user.isAdmin || user.role === 'general_chair' || user.role === 'local_chair'));
  if (!officer) return null;
  const p = presenceOf(rule, presence);
  if (!p) return null;
  const pct = Math.round(p.rate * 100);
  if (!p.intermittent) return 'Returned by the analysis in every one of ' + p.runs + ' control runs.';
  return 'INTERMITTENT: returned in ' + p.n + ' of ' + p.runs + ' control runs (' + pct + '%). That is the analysis on the control description, not on this claim - a rule the analysis does not return every time is one to verify against the agreement text, not to rely on.';
}

// G5.9 / ISS-45 item 2 (2026-09-14, task list section 248): "Two tiers on the page, visually distinct.
// 'Found every time' and 'found sometimes - check this one yourself'. Never one undifferentiated
// list." And item 3: never drop the rotating candidates - ruling 27 is retrieval, and a rule that
// appears 18% of the time may still decide the case. So the rules are TIERED, not filtered: anchors
// first (returned by every control run), then the rest under a heading that says what they are, in
// the order they came. Officers only; a claimant sees the one list, unchanged (6a-12).
// The tiers describe the analysis on the CONTROL description, not this claim (section 20's limit) -
// a rule the ledger has never seen is 'unmeasured', not 'unreliable'.
export const TIER_HEADINGS = {
  anchors: 'Returned by the analysis in every control run',
  sometimes: 'Returned in some control runs only - check each of these against the agreement text yourself',
  unmeasured: 'Not measured on the control description - added by an officer, or outside the control\'s subject',
};

export function tierRules(rules, user, presence) {
  const list = Array.isArray(rules) ? rules : [];
  const officer = !!(user && (user.isAdmin || user.role === 'general_chair' || user.role === 'local_chair'));
  if (!officer) return { tiered: false, anchors: list, sometimes: [], unmeasured: [] };
  const anchors = [], sometimes = [], unmeasured = [];
  for (const r of list) {
    const p = presenceOf(r, presence);
    if (!p) unmeasured.push(r);
    else if (p.intermittent) sometimes.push(r);
    else anchors.push(r);
  }
  return { tiered: true, anchors, sometimes, unmeasured };
}
